import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Permission } from '@typings/app/rbac.types';
import { RbacService } from './rbac.service';

export function rbacGuard(requiredPermission: Permission, redirectTo = '/login'): CanActivateFn {
  return () => {
    const rbac = inject(RbacService);
    const router = inject(Router);
    return rbac.hasPermission(requiredPermission)() ? true : router.createUrlTree([redirectTo]);
  };
}
